module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_aqua_black_vertical-6e53a8e5b7436d4b16db7b900a7766e9.svg";